export { ShippingAddressSkeleton } from './shipping-address-skeleton';
